<template>
  <div>
    <MasterLayout>
      <div class="fuel_consumption_row">
        <div
          class="d-flex justify-content-around rounded-cards primary-bg py-4 p-3 ml-2"
          style="flex: 0 0 25%"
        >
          <div class="text-white manage_card" style="width: 100%">
            <div class="space_justify">
              <p class="amount no_marg_bottom">
                {{ $t("text.extendedReport.cardBalance") }}
              </p>
              <p class="gold-text no_marg_bottom amount">
                {{ cardInfo.cardNumberFormatted }}
              </p>
            </div>
            <div class="text-white manage_card card_margin">
              <p class="no_marg_bottom amount" style="text-align: left">
                ₦ {{ convertThousand(cardInfo.amount) }}
              </p>
            </div>
          </div>
        </div>
        <div
          class="fuel_consumption_row_right_section mr-3 vr__bg"
          style="border-radius: 12px; flex: 0 0 72%"
          :style="[
            {
              backgroundImage: `linear-gradient(rgb(41, 39, 39 , 0.92), rgb(41, 39, 39, 0.92)), url(${backgroundUrl})`,
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
            },
          ]"
        >
          <div
            class="row align-items-center justify-content-center"
            style="height: 100%"
          >
            <!-- <div class="col-md-4" style="display: flex;justify-content: center;">
                <h4 class="text-center text-white">Card Transactions</h4>
            </div> -->
            <div
              class="col-md-8"
              style="display: flex; justify-content: center"
            >
              <div class="drop_down_section mt-2 mr-2">
                <div class="drop_down_div align-items-center">
                  <vue-ctk-date-time-picker
                    v-model="dateRange"
                    :max-date="maxDate"
                    :range="true"
                    :autoClose="true"
                    :locale="this.$root.$i18n.locale"
                    :custom-shortcuts="customShortcuts"
                    color="#4b2d73"
                    format="DDMMYYYY"
                    formatted="DD/MM/YYYY"
                    :label="$t('text.calendar.dateRange')"
                  />
                </div>
              </div>
            </div>
            <div class="col-xl-3 col-md-4 card_action_holder">
              <router-link
                :to="{
                  name: 'fund_card',
                  query: {
                    id: $route.query.vehicleId,
                    cardId: $route.query.cardId,
                    cardNumber: $route.query.cardNumber,
                  },
                }"
                class="fund_card_btn mt-2"
              >
                {{ $t("text.extendedReport.fundCard") }}
              </router-link>
            </div>
          </div>
          <div class="transaction_period_text text-center mt-5"></div>
        </div>
      </div>
      <section class="justify_end row">
        <div class="col-xl-3 col-md-4 card_action_holder">
          <div
            class="row signup-btn card_actions mt-3 pr-2"
            @click="showModal('Change Pin')"
          >
            <div class="col-2 align_center">
              <img src="@/assets/img/remis-pin.svg" alt="" width="35" />
            </div>
            <div class="col-8 mt-3">
              <p>{{ $t("text.extendedReport.changePin") }}</p>
            </div>

            <div class="col-2 text-right mt-3 arrow">
              <img
                class="pin-image"
                src="@/assets/img/Component 3.svg"
                alt=""
              />
            </div>
          </div>
        </div>
        <div class="col-xl-3 col-md-4">
          <div
            class="row light-blue card_actions mt-3 pr-2"
            @click="showModal('Block Card')"
          >
            <div class="col-2 align_center">
              <img src="@/assets/img/delete-icon.svg" alt="" width="35" />
            </div>
            <div class="col-8 mt-3">
              <p>{{ $t("text.extendedReport.blockCard") }}</p>
            </div>

            <div class="col-2 text-right mt-3 arrow">
              <img
                class="pin-image"
                src="@/assets/img/Component 3.svg"
                alt=""
              />
            </div>
          </div>
        </div>
      </section>
      <section class="section__row mt-3">
        <h5>{{ $t("text.extendedReport.cardTrans") }}</h5>
        <div class="">
          <div class="">
            <ejs-grid
              v-show="!showLoader"
              ref="dataGrid"
              :created="refreshGrid"
              :allowPaging="true"
              :allowSorting="true"
              :pageSettings="pageSettings"
              :toolbar="toolbar"
              :searchSettings="search"
              :allowExcelExport="true"
              :allowPdfExport="true"
              :toolbarClick="toolbarClick"
              :locale="usedLang"
            >
              <e-columns>
                <e-column
                  width="70"
                  field="index"
                  :headerText="$t('text.extendedReport.index')"
                ></e-column>
                <e-column
                  width="200"
                  field="date"
                  :headerText="$t('text.extendedReport.date')"
                ></e-column>
                <e-column
                  width="150"
                  field="amount"
                  :headerText="$t('text.extendedReport.amountNaira')"
                  textAlign="right"
                ></e-column>
                <e-column
                  width="100"
                  field="type"
                  :headerText="$t('text.extendedReport.type')"
                  textAlign="center"
                ></e-column>
                <e-column
                  width="200"
                  field="description"
                  :headerText="$t('text.extendedReport.description')"
                  textAlign="right"
                ></e-column>
              </e-columns>
            </ejs-grid>

            <TableLoader :showLoader="showLoader" />
          </div>
        </div>
      </section>
    </MasterLayout>
    <CardActionModal :passedInfo="passedInfo"></CardActionModal>
  </div>
</template>

<script>
import MasterLayout from "@/views/Customer/MasterLayout.vue";
import backgroundUrl from "@/assets/img/danskebank.jpg";
import cardBackgroundUrl from "@/assets/img/Group393.svg";
import CardActionModal from "@/components/modals/Vehicle/cardActionModal";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import {
  Page,
  Sort,
  Toolbar,
  Search,
  Resize,
  ExcelExport,
  PdfExport,
} from "@syncfusion/ej2-vue-grids";
import JQuery from "jquery";
let $ = JQuery;

export default {
  title: "Card Transactions - Epump Portal",
  name: "DashboardHome",
  components: {
    MasterLayout,
    TableLoader,
    CardActionModal,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, Resize, ExcelExport, PdfExport],
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      backgroundUrl,
      cardBackgroundUrl,
      passedInfo: {},
      cardInfo: {},
      transactionsCount: 0,
      showLoader: false,
      startDate: "",
      maxDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      endDate: "",
      pluginStartDate: this.$moment().subtract(7, "days").format("D-M-YYYY"),
      pluginEndDate: this.$moment().format("D-M-YYYY"),
      dateRange: { start: this.pluginStartDate, end: this.pluginEndDate },
      customShortcuts: [
        { key: "Today", label: this.$t("text.calendar.today"), value: "day" },
        {
          key: "yesterday",
          label: this.$t("text.calendar.yesterday"),
          value: "-day",
        },
        {
          key: "last7Days",
          label: this.$t("text.calendar.last7Days"),
          value: 7,
        },
        {
          key: "lastWeek",
          label: this.$t("text.calendar.lastWeek"),
          value: "-isoWeek",
        },
        {
          key: "last30Days",
          label: this.$t("text.calendar.last30Days"),
          value: 30,
        },
        {
          key: "lastMonth",
          label: this.$t("text.calendar.lastMonth"),
          value: "-month",
        },
      ],
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },
    };
  },
  watch: {
    dateRange: function (newRange, oldRange) {
      if (!this.cardInfo.uniqueId) {
        return;
      }
      if (newRange.start !== null && newRange.end !== null) {
        this.startDate = this.$moment(newRange.start, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );
        this.endDate = this.$moment(newRange.end, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );

        this.getTransactions();
      }
    },
  },
  created() {
    this.dateRange.start = "";
    this.dateRange.end = "";
  },
  mounted() {
    if (this.$route.query.cardId && !this.$route.query.vehicleId) {
      this.cardId = this.$route.query.cardId;
      let card = sessionStorage.getItem(this.cardId);
      if (!card) {
        let dt = JSON.parse(localStorage.getItem("cardsList"));
        dt.forEach((my) => {
          if (my.uniqueId === this.cardId) {
            card = JSON.stringify(my);
            sessionStorage.setItem(this.cardId, card);
          }
        });
      }

      this.cardInfo = JSON.parse(card);
      this.getTransactions();
    }
    if (this.$route.query.vehicleId) {
      this.getCardDetails();
    }
    $(".e-input").keyup(function (e) {
      searchFun(e);
    });
    function searchFun(event) {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      grid.search(value);
    }
  },
  methods: {
    dataBound: function () {
      this.$refs.dataGrid.autoFitColumns();
    },
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          let pdfExportProperties = {
            pageOrientation: "Landscape",
            fileName: "Card Transactions.pdf",
          };
          break;
        case "Excel Export":
          let excelExportProperties = {
            fileName: "Vehicles Fuel Consumption.xlsx",
          };
          this.$refs.dataGrid.excelExport(excelExportProperties);
          break;
      }
    },
    refreshGrid() {
      if (this.$refs.dataGrid) {
        this.$refs.dataGrid.refresh();
      }
    },
    getTransactions() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Card/GetTransactions/${this.cardInfo.uniqueId}?startDate=${this.startDate}&endDate=${this.endDate}`,
          configObject.authConfig()
        )
        .then((res) => {
          let index = 0;
          res.data.forEach((cur) => {
            ++index;
            cur.index = index;
            cur.amount = this.convertThousand(cur.amountSpent);
            cur.date = this.$moment(cur.date).format("DD MMMM YYYY hh:mm A");
            cur.type = cur.type == "Remove" ? "Debit" : "Credit";
          });
          this.showLoader = false;
          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: res.data,
          });
          this.refreshGrid();
        })
        .catch((error) => {
          this.loading = false;
        });
    },
    getCardDetails() {
      this.axios
        .post(
          `${configObject.apiBaseUrl}/Card/VehicleCard/${this.$route.query.vehicleId}`,
          {},
          configObject.authConfig()
        )
        .then((response) => {
          response.data = response.data[0];
          const cardBlock_1 = response.data.cardNumber.substring(0, 3);
          const cardBlock_2 = response.data.cardNumber.substring(3, 6);
          const cardBlock_3 = response.data.cardNumber.slice(6);
          response.data.cardNumberFormatted =
            cardBlock_1 + "   " + cardBlock_2 + "   " + cardBlock_3;
          this.cardInfo = response.data;
          this.getTransactions();
        })
        .catch(() => {});
    },
    showModal(action) {
      this.$modal.show("cardActionModal");
      this.passedInfo = {
        action,
        cardNumber: this.cardInfo.cardNumberFormatted,
        uniqueId: this.cardInfo.uniqueId,
      };
    },
    convertThousand(request) {
      if (!isFinite(request)) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
</script>

<style>
@media screen and (max-width: 602px) {
  .cardActionModal .v--modal-box.v--modal {
    top: 50%;
    width: 90% !important;
    margin: 0 auto !important;
    height: 350px !important;
    left: 0 !important;
    overflow: auto;
  }

  .left-modal-view {
    display: none !important;
  }

  .desktop-modal-container .right-modal-view {
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
  }
}
</style>
